export const UPDATE_QUERY = 'UPDATE_QUERY';
export const UPDATE_SORT = 'UPDATE_SORT';
export const TOGGLE_AGGREGATION = 'TOGGLE_AGGREGATION';
export const TOGGLE_EXCLUDE_MOYENS_ANNEXES = 'TOGGLE_EXCLUDE_MOYENS_ANNEXES';
export const UPDATE_DATES = 'UPDATE_DATES';
export const UPDATE_PARTIES = 'UPDATE_PARTIES';
export const UPDATE_LAWYER_FILTER = 'UPDATE_LAWYER_FILTER';
export const UPDATE_ENTERPRISE_FILTER = 'UPDATE_ENTERPRISE_FILTER';
export const UPDATE_LAW_OFFICE_FILTER = 'UPDATE_LAW_OFFICE_FILTER';
export const UPDATE_TYPE = 'UPDATE_TYPE';
export const FOLLOW_ADVICE = 'FOLLOW_ADVICE';
export const FORCE_TYPO = 'FORCE_TYPO';
export const RESET_FILTERS = 'RESET_FILTERS';
export const RESET_FROM_QUERY_PASTE = 'RESET_FROM_QUERY_PASTE';
export const SHOW_ALL_RESULTS = 'SHOW_ALL_RESULTS';
export const SELECT_KEYWORD = 'SELECT_KEYWORD';
export const UNSELECT_KEYWORD = 'UNSELECT_KEYWORD';
export const ADD_RESTRICTION_TO_LAW_ARTICLE_IDS =
  'ADD_RESTRICTION_TO_LAW_ARTICLE_IDS';
export const ADD_RESTRICTION_TO_LAW_ARTICLE_ID =
  'ADD_RESTRICTION_TO_LAW_ARTICLE_ID';
export const REMOVE_RESTRICTION_TO_LAW_ARTICLE_ID =
  'REMOVE_RESTRICTION_TO_LAW_ARTICLE_ID';
export const FILTER_ON_SPECIFIC_ARTICLE_VERSION =
  'FILTER_ON_SPECIFIC_ARTICLE_VERSION';
export const RESTRICT_TO_LAWYER = 'RESTRICT_TO_LAWYER';
export const RESTRICT_TO_ENTERPRISE = 'RESTRICT_TO_ENTERPRISE';
export const CLEAR_QUERY_PARAMS = 'CLEAR_QUERY_PARAMS';
export const SYNC_URL_PARAMS = 'SYNC_URL_PARAMS';
export const USER_TYPE = 'USER_TYPE';
export const USER_ENHANCED_QUERY_BY_PASTING = 'USER_ENHANCED_QUERY_BY_PASTING';
export const MANUAL_SUBMIT_SEARCH = 'MANUAL_SUBMIT_SEARCH';

export const SEARCH_REQUEST = 'SEARCH_REQUEST';
export const PAGINATION_REQUEST = 'PAGINATION_REQUEST';
export const SYNC_QUERY_RESPONSE = 'SYNC_QUERY_RESPONSE';
export const SYNC_PAGINATION_RESPONSE = 'SYNC_PAGINATION_RESPONSE';
export const SYNC_COUNTS = 'SYNC_COUNTS';
export const SEARCH_ERROR = 'SEARCH_ERROR';
export const CANCEL_REQUEST = 'CANCEL_REQUEST';
export const PAGINATION_ERROR = 'PAGINATION_ERROR';
export const CANCEL_PAGINATION_REQUEST = 'CANCEL_PAGINATION_REQUEST';

export const TOGGLE_SEARCH_MENU = 'TOGGLE_SEARCH_MENU';
export const TOGGLE_COUNTRY = 'TOGGLE_COUNTRY';

export const SYNC_AGGREGATIONS = 'SYNC_AGGREGATIONS';
export const TOGGLE_AGGREGATION_PANE = 'TOGGLE_AGGREGATION_PANE';

export const SWITCH_SEARCH_FEATURES = 'SWITCH_SEARCH_FEATURES';
